import { useTranslation } from "react-i18next";
import {
  ColumnDirective,
  ColumnsDirective,
  GridComponent,
  Inject,
  Page,
} from "@syncfusion/ej2-react-grids";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { FaCar, FaCarAlt } from "react-icons/fa";
import { vehicleService } from "../../../Services/vehicle.service";

// Syncfusion css
import "@syncfusion/ej2-base/styles/bootstrap5.css";
import "@syncfusion/ej2-buttons/styles/bootstrap5.css";
import "@syncfusion/ej2-dropdowns/styles/bootstrap5.css";
import "@syncfusion/ej2-grids/styles/bootstrap5.css";
import "@syncfusion/ej2-inputs/styles/bootstrap5.css";
import "@syncfusion/ej2-navigations/styles/bootstrap5.css";
import "@syncfusion/ej2-popups/styles/bootstrap5.css";
import "@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";

import { HiOutlineRectangleGroup } from "react-icons/hi2";
import { IoIosPin } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Filters } from "../../../components/Filters";
import { useSelected } from "../../../contexts/SelectedContext";
import {
  getLocationCoordinates,
  locationsService,
} from "../../../Services/locations.service";
import { toDateTime } from "../../../Services/string.service";
import { visitsService } from "../../../Services/visits.service";
import Spinner from "../../Components/Spinner";
import EmptyData from "../../../components/EmptyData";
import ModalVisits from "./ModalVisits";

export default function VehicleNearest() {
  const { t } = useTranslation();
  const [opcaoSelecionada, setOpcaoSelecionada] = useState("");
  const [vehicleIdSelecionado] = useState(0);
  const [vehicleGroupIdSelecionado] = useState(0);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [pageSize, setPageSize] = useState(10);
  const [addres, setAddres] = useState("");
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [dataFilterVisits, setDataFilterVisits] = useState([]);
  const [dataChooseVisits, setDataChooseVisits] = useState([]);
  const [isLoadingVehicles, setIsLoadingVehicles] = useState(false);
  const [dataFilterAddress, setDataFilterAddress] = useState([]);

  const { selectedValues } = useSelected();

  const selectedGroup = selectedValues.veiculos?.[0] || null;
  const selectedVehicles = selectedValues.veiculosGroups?.[0] || null;

  const location = useLocation();

  // Coordenadas selecionadas
  const [selectedCoords, setSelectedCoords] = useState({
    latitude: null,
    longitude: null,
  });

  const [dataGroup, setDataGroup] = useState([]);
  const [show, setShow] = useState(false);

  const { pageTitle } = useSelector(
    (rootReducer) => rootReducer.layoutDataReducer
  );

  const handleChange = (event) => {
    setOpcaoSelecionada(event.target.value);
  };

  const handleSelectVehicle = async (vehicleId, groupId) => {
    setShow(true);
    try {
      const response = await vehicleService.fetchTrackVehiclesAll(
        selectedGroup,
        selectedVehicles
      );
      if (response) {
        setDataFilter(response);
      }
    } catch (error) {}
  };

  const handleSelectAddres = async (addres) => {
    setDataLoading(true);
    try {
      setShow(false);
      const response = await locationsService.searchByAddress(addres);
      if (response) {
        setShow(true); // mesmo sem dados, precisa mostrar a mensagem
        setDataFilterAddress(response);
        setDataLoading(false);
      } else {
        setDataFilterAddress([]);
        setShow(true); // mesmo sem dados, precisa mostrar a mensagem
        setDataLoading(false);
      }
    } catch (error) {
      console.error("Erro ao buscar endereço:", error);
      setDataFilterAddress([]);
      setShow(true);
    }
  };

  /*
  const handleGroupChange = async (groupId) => {
    try {
      setVehicleGroupIdSelecionado(selectedGroup);
      const response = await vehicleService.fetchVehicles(selectedGroup);
      
      // Garante que sempre seja um array válido
      if (Array.isArray(response)) {
        setData(response);
      } else {
        setData([]);
        if (response?.error) {
          console.log("Erro ao buscar veículos:", response.message || response.friendlyMessage);
        }
      }
    } catch (error) {
      console.error("Erro ao buscar veículos:", error);
      setData([]);
    }
  };
  */

  const handleRowSelected = (args) => {
    // args.data é o item da linha selecionada (Syncfusion)
    const { latitude, longitude } = args?.data ?? {};
    const lat = Number(latitude);
    const lng = Number(longitude);

    if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
      setSelectedCoords({ latitude: lat, longitude: lng });
      setShowSearchModal(true);
    } else {
      // opcional: trate quando a linha não tiver coordenadas válidas
      console.warn(
        "Linha selecionada sem latitude/longitude válidas:",
        args?.data
      );
    }

    const selectedItem = args.data;
    setDataChooseVisits(selectedItem);
  };

  useEffect(() => {
    const fetchData = async () => {
      setDataLoading(false);
      if (opcaoSelecionada === "veiculo") {
        const responseVehiclesGroups = await vehicleService.fetchGroups();

        // Carrega veículos baseado no grupo selecionado
        let responseVehicles;
        if (selectedGroup && selectedGroup !== 0) {
          setIsLoadingVehicles(true);
          responseVehicles = await vehicleService.fetchVehicles(selectedGroup);
          setIsLoadingVehicles(false);
        } else {
          responseVehicles = await vehicleService.fetchVehicles(0);
        }

        // Garante que sempre sejam arrays válidos
        if (Array.isArray(responseVehicles)) {
          setData(responseVehicles);
        } else {
          setData([]);
          if (responseVehicles?.error) {
            console.log("Erro ao buscar veículos:", responseVehicles.message || responseVehicles.friendlyMessage);
          }
        }

        if (Array.isArray(responseVehiclesGroups)) {
          setDataGroup(responseVehiclesGroups);
        } else {
          setDataGroup([]);
          if (responseVehiclesGroups?.error) {
            console.log("Erro ao buscar grupos:", responseVehiclesGroups.message || responseVehiclesGroups.friendlyMessage);
          }
        }
      }
      if (opcaoSelecionada === "ponto") {
        setDataLoading(true);
        const responseVehicles = await visitsService.fetchVisits(2, 0);

        if (Array.isArray(responseVehicles)) {
          setDataFilterVisits(responseVehicles);
        } else {
          setDataFilterVisits([]);
        }
        setDataLoading(false);
      }
    };

    fetchData();
  }, [opcaoSelecionada, selectedGroup]);

  // Função para calcular o pageSize baseado na altura da tela
  const calculatePageSize = () => {
    const windowHeight = window.innerHeight;

    // Altura dos elementos fixos baseado no layout atual
    let headerHeight = 80; // Header da aplicação (reduzido)
    let cardPadding = 20; // Padding do card (20px top + 20px bottom)
    let titleHeight = 60; // Título e controles (aumentado para incluir radio buttons)
    let gridHeaderHeight = 25; // Cabeçalho do grid
    let paginationHeight = 30; // Paginação (aumentado)
    let rowHeight = 30; // Altura de uma linha

    // Altura total dos elementos fixos
    const totalFixedHeight =
      headerHeight +
      cardPadding +
      titleHeight +
      gridHeaderHeight +
      paginationHeight;

    // Altura disponível para as linhas
    const availableHeight = windowHeight - totalFixedHeight;

    // Calcular quantas linhas cabem
    const calculatedPageSize = Math.max(
      Math.floor(availableHeight / rowHeight),
      10
    );

    console.log("Calculando pageSize:", {
      windowHeight,
      totalFixedHeight,
      availableHeight,
      rowHeight,
      calculatedPageSize,
    });

    setPageSize(calculatedPageSize);
  };

  useEffect(() => {
    dispatch({ type: "title", value: t("VEHICLE_NEAREST.TITLE") });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  // useLayoutEffect para calcular pageSize quando o componente é montado
  useLayoutEffect(() => {
    calculatePageSize();
  }, [location.pathname]);

  // useLayoutEffect para calcular pageSize quando a opção muda
  useLayoutEffect(() => {
    calculatePageSize();
  }, [opcaoSelecionada]);

  // useLayoutEffect para calcular pageSize quando o show muda
  useLayoutEffect(() => {
    if (show) {
      calculatePageSize();
    }
  }, [show]);

  // useLayoutEffect para calcular pageSize quando os dados são carregados
  useLayoutEffect(() => {
    if (
      dataFilterVisits?.length > 0 ||
      dataFilter?.vehiclesUser?.length > 0 ||
      dataFilterAddress?.length > 0
    ) {
      calculatePageSize();
    }
  }, [dataFilterVisits, dataFilter, dataFilterAddress]);

  // useLayoutEffect para calcular pageSize quando o loading termina
  useLayoutEffect(() => {
    if (!dataLoading) {
      calculatePageSize();
    }
  }, [dataLoading]);

  // Effect para redimensionamento da janela
  useEffect(() => {
    const handleResize = () => {
      calculatePageSize();
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="card" style={{ margin: 20, padding: 20 }}>
      <ModalVisits
        show={showSearchModal}
        handleClose={setShowSearchModal}
        dataFilterAddress={dataFilterAddress}
        dataVehicle={dataFilter?.vehiclesUser ?? dataFilterAddress}
        // selectedIndex={dataFilter.vehiclesUser[0].vehicleId}
        dataVisits={dataChooseVisits}
        opcaoSelecionada={opcaoSelecionada}
        latitude={selectedCoords.latitude}
        longitude={selectedCoords.longitude}
      />

      <p>{t("VEHICLE_NEAREST.SELECT_METHOD")}</p>
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        <label>
          <input
            className="form-check-input"
            type="radio"
            name="opcao"
            value="endereco"
            style={{ marginRight: 4 }}
            checked={opcaoSelecionada === "endereco"}
            onChange={handleChange}
          />
          {t("VEHICLE_NEAREST.ADDRESS")}
        </label>

        <label>
          <input
            type="radio"
            className="form-check-input"
            name="opcao"
            value="veiculo"
            style={{ marginRight: 4 }}
            checked={opcaoSelecionada === "veiculo"}
            onChange={handleChange}
          />
          {t("VEHICLE_NEAREST.VEHICLE")}
        </label>

        <label>
          <input
            type="radio"
            className="form-check-input"
            name="opcao"
            value="ponto"
            style={{ marginRight: 4 }}
            checked={opcaoSelecionada === "ponto"}
            onChange={handleChange}
          />
          {t("VEHICLE_NEAREST.VISIT_POINT")}
        </label>
      </div>

      {opcaoSelecionada === "endereco" && (
        <div className="card" style={{ marginTop: 16, padding: 16 }}>
          <form
            onSubmit={(e) => {
              e.preventDefault(); // evita o reload da página
              handleSelectAddres(addres); // chama a função como se tivesse clicado no botão
            }}
          >
            <div>
              <h4>{t("VEHICLE_NEAREST.ENTER_ADDRESS")}</h4>
              <div className="row">
                <div className="col-md-9 d-flex align-items-center">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t("VEHICLE_NEAREST.ADDRESS")}
                    name="addres"
                    id="addres"
                    tabIndex={2}
                    value={addres}
                    onChange={(e) => setAddres(e.target.value)}
                  />
                </div>

                <div className="col-md-3 d-flex align-items-center">
                  <button
                    type="submit" // IMPORTANTE: esse botão agora é submit
                    className="btn btn-primary w-100"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                    }}
                  >
                    <IoIosPin />
                    {t("VEHICLE_NEAREST.LOCATE_ADDRESS")}
                  </button>
                </div>
              </div>
            </div>
          </form>

          {dataLoading ? (
            <div className="d-flex justify-content-center my-5">
              <Spinner />
            </div>
          ) : show === true ? (
            Array.isArray(dataFilterAddress) && dataFilterAddress.length > 0 ? (
              <GridComponent
                ref={gridRef}
                key={`address-grid-${pageSize}`}
                dataSource={dataFilterAddress}
                allowPaging={true}
                pageSettings={{ pageSize }}
                height="auto"
                style={{ marginTop: 16 }}
                locale="pt-BR"
                rowSelected={handleRowSelected}
                rowDataBound={(args) => {
                  args.row.style.cursor = "pointer"; // 👈 Aplica o estilo aqui
                }}
              >
                <ColumnsDirective>
                  <ColumnDirective
                    field="location"
                    headerText={t("VEHICLE_NEAREST.ADDRESS")}
                    width="200"
                  />
                </ColumnsDirective>
              </GridComponent>
            ) : (
              <EmptyData />
            )
          ) : null}
        </div>
      )}

      {opcaoSelecionada === "veiculo" && (
        <div className="card" style={{ marginTop: 16, padding: 16 }}>
          <h4>{t("VEHICLE_NEAREST.SELECT_VEHICLE_DISTANCE")}</h4>
          <div className="row">
            <div className="mb-1 col-md-4">
              <Filters
                pageTitle={pageTitle}
                id={"veiculos"}
                isMulti={false}
                title={t("VEHICLE_NEAREST.GROUPS")}
                hasSubTitle={true}
                subTitle={t("VEHICLE_NEAREST.ALL_GROUPS")}
                options={dataGroup || []}
                icon={HiOutlineRectangleGroup}
                hasIcon={true}
              />
            </div>
            <div className="mb-1 col-md-4">
              <Filters
                pageTitle={pageTitle}
                id={"veiculosGroups"}
                isMulti={false}
                title={t("VEHICLE_NEAREST.VEHICLES")}
                hasSubTitle={true}
                subTitle={t("VEHICLE_NEAREST.ALL_VEHICLES")}
                options={data || []}
                icon={FaCar}
                hasIcon={true}
                isLoading={isLoadingVehicles}
              />
            </div>
            <div className="mb-1 col-md-2 offset-md-1">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() =>
                  handleSelectVehicle(
                    vehicleIdSelecionado,
                    vehicleGroupIdSelecionado
                  )
                }
              >
                <FaCarAlt style={{ paddingRight: "4px" }} size={20} />
                {t("VEHICLE_NEAREST.FILTER")}
              </button>
            </div>
          </div>

          {dataLoading ? (
            <div className="d-flex justify-content-center my-5">
              <Spinner />
            </div>
          ) : show === true ? (
            Array.isArray(dataFilter?.vehiclesUser) &&
            dataFilter.vehiclesUser.length > 0 ? (
              <GridComponent
                ref={gridRef}
                key={`vehicle-grid-${pageSize}`}
                locale="pt-BR"
                dataSource={dataFilter.vehiclesUser}
                allowPaging={true}
                pageSettings={{ pageSize }}
                height="auto"
                style={{ marginTop: 16 }}
                rowSelected={handleRowSelected}
                rowDataBound={(args) => {
                  args.row.style.cursor = "pointer";
                }}
              >
                <ColumnsDirective>
                  <ColumnDirective
                    clipMode="EllipsisWithTooltip"
                    field="vehicleGroupName"
                    headerText={t("VEHICLE_NEAREST.GROUP")}
                    width="100"
                  />
                  <ColumnDirective
                    clipMode="EllipsisWithTooltip"
                    field="plate"
                    headerText={t("COMMON.PLATE")}
                    width="100"
                  />
                  <ColumnDirective
                    field="generatedAt"
                    headerText={t("VEHICLE_NEAREST.DATE_TIME")}
                    width="130"
                    clipMode="EllipsisWithTooltip"
                    template={(props) => {
                      const formattedDate = toDateTime(props.generatedAt); // usa sua função
                      return <span>{formattedDate}</span>;
                    }}
                  />
                  <ColumnDirective
                    clipMode="EllipsisWithTooltip"
                    field="location"
                    headerText={t("VEHICLE_NEAREST.ADDRESS")}
                    width="500"
                    template={(props) => {
                      return (
                        <a
                          href={`https://maps.google.com/?q=${getLocationCoordinates(
                            "location",
                            props
                          )}`}
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline",
                            color: "inherit",
                            fontSize: "13px",
                          }}
                        >
                          <div>{props.location}</div>
                        </a>
                      );
                    }}
                  />
                </ColumnsDirective>
                <Inject services={[Page]} />
              </GridComponent>
            ) : (
              <EmptyData />
            )
          ) : null}
        </div>
      )}

      {opcaoSelecionada === "ponto" && (
        <div className="card" style={{ marginTop: 16, padding: 16 }}>
          <h4>{t("VEHICLE_NEAREST.SELECT_POINT")}</h4>
          {dataLoading ? (
            <Spinner />
          ) : Array.isArray(dataFilterVisits) && dataFilterVisits.length > 0 ? (
            <GridComponent
              ref={gridRef}
              key={`visits-grid-${pageSize}`}
              dataSource={dataFilterVisits}
              allowPaging={true}
              pageSettings={{ pageSize }}
              height="auto"
              style={{ marginTop: 16 }}
              locale="pt-BR"
              rowSelected={handleRowSelected}
              rowDataBound={(args) => {
                args.row.style.cursor = "pointer";
              }}
            >
              <ColumnsDirective>
                <ColumnDirective
                  clipMode="EllipsisWithTooltip"
                  field="markerDescription"
                  headerText={t("COMMON.DESCRIPTION")}
                  width="80"
                />
                <ColumnDirective
                  clipMode="EllipsisWithTooltip"
                  field="event"
                  headerText={t("COMMON.TYPE")}
                  width="120"
                />
                <ColumnDirective
                  clipMode="EllipsisWithTooltip"
                  field="address"
                  headerText={t("VEHICLE_NEAREST.ADDRESS")}
                  width="300"
                  template={(props) => {
                    return (
                      <a
                        href={`https://maps.google.com/?q=${getLocationCoordinates(
                          "address",
                          props
                        )}`}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          cursor: "pointer",
                          textDecoration: "underline",
                          color: "inherit",
                          fontSize: "13px",
                        }}
                      >
                        <div>{props.address}</div>
                      </a>
                    );
                  }}
                />
              </ColumnsDirective>
              <Inject services={[Page]} />
            </GridComponent>
          ) : (
            <EmptyData />
          )}
        </div>
      )}
    </div>
  );
}
